import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
    name: "companySlice",
    initialState: {
        companyProfileDetails: "",
        companyAccountDetails: "",
        companyUserDetails: "",
        companyProductDetails: [],
        companyUserAccountProductDetails: "",
        companyAuthMatrixDetails: [],
        companyAuthMatrixFurtherDetails: [],
        companyGroupDetails: [],
        companyAuthMatrixDetailsForm: "",
        editFlag: false,
        companyLinkedparserHeads: [],
        companyProductFormData: [],
        companyProductEditFlag: false,
        companyUsersFormData: [],
        companyUsersEditFlag: false,
        companyAccountFormData: [],
        companyAccountEditFlag: false,
        companyUsersAccountProductFormData: [],
        companyUsersAccountProductEditFlag: false,
        companyGroupFormData: [],
        companyGroupEditFlag: false,
        parserHeadDetailsForm: "",
        parserHeadEditFlag: false,
        parseHeadDetails: [],
        parseHeadFurtherDetails: [],
        parseHeadId: "",
        parserHeadDetailsEditFlag: false,
        parserHeadDetailsFormData: "",
        parserDetailId: "",
    },
    reducers: {
        ADDCOMPANYPROFILE_SUCCESS: (state, action) => {
            return {
                ...state,
                companyProfileDetails: action.payload,
            };
        },
        ADDCOMPANYPROFILE_ERROR: (state) => {
            return {
                ...state,
                companyProfileDetails: "",
            };
        },
        GETCOMPANYDETAILS_SUCCESS: (state, action) => {
            return {
                ...state,
                companyProfileDetails: action.payload,
            };
        },
        GETCOMPANYDETAILS_ERROR: (state) => {
            return {
                ...state,
                companyProfileDetails: "",
            };
        },
        GETAUTHMATRIXFURTHERDETAILS_SUCCESS: (state, action) => {
            console.log("action ::", action.payload?.tblAuthMatrixDetails);
            return {
                ...state,
                companyAuthMatrixFurtherDetails: action.payload?.tblAuthMatrixDetails,
            };
        },
        GETAUTHMATRIXFURTHERDETAILS_ERROR: (state) => {
            return {
                ...state,
                companyAuthMatrixFurtherDetails: "",
            };
        },
        SETAUTHMATRIXFURTHERDETAILS_SUCCESS: (state, action) => {
            return {
                ...state,
                companyAuthMatrixFurtherDetails: action.payload?.tblAuthMatrixDetails,
                companyAuthMatrixDetailsForm: action.payload,
                editFlag: true,
            };
        },

        SETAUTHMATRIXFURTHERDETAILS_ERROR: (state) => {
            return {
                ...state,
                companyAuthMatrixFurtherDetails: [],
            };
        },
        SETAUTHMATRIXFURTHERDETAILS_NULL_SUCCESS: (state, action) => {
            return {
                ...state,
                companyAuthMatrixFurtherDetails: [],
            };
        },
        SETEDITFLAG_SUCCESS: (state, action) => {
            return {
                ...state,
                editFlag: action.payload,
            };
        },
        GETPARSERHEADDETAILS_SUCCESS: (state, action) => {
            return {
                ...state,
                parseHeadDetails: action.payload,
            };
        },
        GETPARSERHEADDETAILS_ERROR: (state) => {
            return {
                ...state,
                parseHeadDetails: "",
            };
        },
        GETPARSERHEADFURTHERDETAILS_SUCCESS: (state, action) => {
            return {
                ...state,
                parseHeadFurtherDetails: action.payload?.parserDetails,
            };
        },
        GETPARSERHEADFURTHERDETAILS_ERROR: (state) => {
            return {
                ...state,
                parseHeadFurtherDetails: "",
            };
        },
        SETPARSERHEADFURTHERDETAILS_SUCCESS: (state, action) => {
            return {
                ...state,
                parseHeadFurtherDetails: action.payload?.parserDetails,
                parseHeadId: action.payload?.parserHeadId,
                parserHeadDetailsForm: action.payload,
                parserHeadEditFlag: true,
                // parserHeadDetailsEditFlag: true,
            };
        },
        SETPARSERHEADFURTHERDETAILSDATA_SUCCESS: (state, action) => {
            return {
                ...state,
                parserDetailId: action.payload?.parserDetailId,
                parserHeadDetailsFormData: action.payload,
                parserHeadDetailsEditFlag: true,
            };
        },
        SETPARSEREDITFLAG_SUCCESS: (state, action) => {
            return {
                ...state,
                parserHeadEditFlag: action.payload,
            };
        },
        SETPARSERHEADDETAILSEDITFLAG_SUCCESS: (state, action) => {
            return {
                ...state,
                parserHeadDetailsEditFlag: action.payload,
            };
        },
        SETPARSERHEADFURTHERDETAILS_NULL_SUCCESS: (state, action) => {
            return {
                ...state,
                parseHeadFurtherDetails: [],
            };
        },
        SETCOMPANYPRODUCTFORMDATA_SUCCESS: (state, action) => {
            return {
                ...state,
                companyProductFormData: action.payload,
                companyProductEditFlag: true,
            };
        },

        SETCOMPANYPRODUCTFORMDATA_ERROR: (state) => {
            return {
                ...state,
                companyProductFormData: [],
            };
        },
        SETCOMPANYPRODUCTFORMDATA_NULL_SUCCESS: (state, action) => {
            return {
                ...state,
                companyProductFormData: [],
            };
        },
        SETCOMPANYACCOUNTFORMDATA_SUCCESS: (state, action) => {
            return {
                ...state,
                companyAccountFormData: action.payload,
                companyAccountEditFlag: true,
            };
        },

        SETCOMPANYACCOUNTFORMDATA_ERROR: (state) => {
            return {
                ...state,
                companyAccountFormData: [],
            };
        },
        SETCOMPANYACCOUNTFORMDATA_NULL_SUCCESS: (state, action) => {
            return {
                ...state,
                companyAccountFormData: [],
            };
        },
        SETCOMPANYACCOUNTANDPRODUCTFORMDATA_SUCCESS: (state, action) => {
            return {
                ...state,
                companyUsersAccountProductFormData: action.payload,
                companyUsersAccountProductEditFlag: true,
            };
        },

        SETCOMPANYACCOUNTANDPRODUCTFORMDATA_ERROR: (state) => {
            return {
                ...state,
                companyUsersAccountProductFormData: [],
            };
        },
        SETCOMPANYACCOUNTANDPRODUCTFORMDATA_NULL_SUCCESS: (state, action) => {
            return {
                ...state,
                companyUsersAccountProductFormData: [],
            };
        },
        SETCOMPANYPRODUCTFLAG_SUCCESS: (state, action) => {
            return {
                ...state,
                companyProductEditFlag: action.payload,
            };
        },
        SETCOMPANYACCOUNTFLAG_SUCCESS: (state, action) => {
            return {
                ...state,
                companyAccountEditFlag: action.payload,
            };
        },
        SETCOMPANYACCOUNTANDPRODUCTFLAG_SUCCESS: (state, action) => {
            return {
                ...state,
                companyUsersAccountProductEditFlag: action.payload,
            };
        },
        GETCOMPANYPRODUCTDETAIL_SUCCESS: (state, action) => {
            return {
                ...state,
                companyProductDetails: action.payload,
            };
        },
        GETCOMPANYPRODUCTDETAIL_ERROR: (state) => {
            return {
                ...state,
                companyProductDetails: "",
            };
        },
        GETCOMPANYACCOUNTAUTHORIZATION_SUCCESS: (state, action) => {
            return {
                ...state,
                companyAuthMatrixDetails: action.payload,
            };
        },
        GETCOMPANYACCOUNTAUTHORIZATION_ERROR: (state) => {
            return {
                ...state,
                companyAuthMatrixDetails: [],
            };
        },
        SETCOMPANYUSERSFORMDATA_SUCCESS: (state, action) => {
            return {
                ...state,
                companyUsersFormData: action.payload,
                companyUsersEditFlag: true,
            };
        },

        SETCOMPANYUSERSFORMDATA_ERROR: (state) => {
            return {
                ...state,
                companyAuthMatrixFurtherDetails: [],
            };
        },
        SETCOMPANYUSERSFORMDATA_NULL_SUCCESS: (state, action) => {
            return {
                ...state,
                companyUsersFormData: [],
            };
        },
        SETCOMPANYUSERSFLAG_SUCCESS: (state, action) => {
            return {
                ...state,
                companyUsersEditFlag: action.payload,
            };
        },
        GETCOMPANYUSERSDETAIL_SUCCESS: (state, action) => {
            return {
                ...state,
                companyUserDetails: action.payload,
            };
        },
        GETCOMPANYUSERSDETAIL_ERROR: (state) => {
            return {
                ...state,
                companyUserDetails: "",
            };
        },
        GETCOMPANYACCOUNTDETAIL_SUCCESS: (state, action) => {
            return {
                ...state,
                companyAccountDetails: action.payload,
            };
        },
        GETCOMPANYACCOUNTDETAIL_ERROR: (state) => {
            return {
                ...state,
                companyAccountDetails: "",
            };
        },

        GETCOMPANYACCOUNTANDPRODUCT_SUCCESS: (state, action) => {
            return {
                ...state,
                companyUserAccountProductDetails: action.payload,
            };
        },
        GETCOMPANYACCOUNTANDPRODUCT_ERROR: (state) => {
            return {
                ...state,
                companyUserAccountProductDetails: "",
            };
        },
        SETCOMPANYGROUPFORMDATA_SUCCESS: (state, action) => {
            return {
                ...state,
                companyGroupFormData: action.payload,
                companyGroupEditFlag: true,
            };
        },

        SETCOMPANYGROUPFORMDATA_ERROR: (state) => {
            return {
                ...state,
                companyGroupDetails: [],
            };
        },
        SETCOMPANYGROUPFORMDATA_NULL_SUCCESS: (state, action) => {
            return {
                ...state,
                companyGroupFormData: [],
            };
        },
        SETCOMPANYGROUPFLAG_SUCCESS: (state, action) => {
            return {
                ...state,
                companyGroupEditFlag: action.payload,
            };
        },
        GETCOMPANYGROUPDETAIL_SUCCESS: (state, action) => {
            return {
                ...state,
                companyGroupDetails: action.payload,
            };
        },
        GETCOMPANYGROUPDETAIL_ERROR: (state) => {
            return {
                ...state,
                companyGroupDetails: "",
            };
        },
        GETCOMPANYPARSERLINKEDHEADDETAILS_SUCCESS: (state, action) => {
            return {
                ...state,
                companyLinkedparserHeads: action.payload,
            };
        },
        GETCOMPANYPARSERLINKEDHEADDETAILS_ERROR: (state) => {
            return {
                ...state,
                companyLinkedparserHeads: "",
            };
        },
    },
});

export const {
    ADDCOMPANYPROFILE_SUCCESS,
    ADDCOMPANYPROFILE_ERROR,
    GETCOMPANYDETAILS_ERROR,
    GETCOMPANYDETAILS_SUCCESS,
    GETAUTHMATRIXFURTHERDETAILS_SUCCESS,
    GETAUTHMATRIXFURTHERDETAILS_ERROR,
    SETAUTHMATRIXFURTHERDETAILS_SUCCESS,
    SETAUTHMATRIXFURTHERDETAILS_ERROR,
    SETEDITFLAG_SUCCESS,
    SETCOMPANYPRODUCTFLAG_SUCCESS,
    SETAUTHMATRIXFURTHERDETAILS_NULL_SUCCESS,
    GETPARSERHEADDETAILS_SUCCESS,
    GETPARSERHEADDETAILS_ERROR,
    SETPARSERHEADFURTHERDETAILS_SUCCESS,
    SETPARSERHEADFURTHERDETAILSDATA_SUCCESS,
    SETPARSERHEADFURTHERDETAILS_NULL_SUCCESS,
    SETCOMPANYPRODUCTFORMDATA_SUCCESS,
    SETCOMPANYPRODUCTFORMDATA_ERROR,
    SETCOMPANYPRODUCTFORMDATA_NULL_SUCCESS,
    GETCOMPANYPRODUCTDETAIL_SUCCESS,
    GETCOMPANYPRODUCTDETAIL_ERROR,
    SETCOMPANYUSERSFORMDATA_SUCCESS,
    SETCOMPANYUSERSFORMDATA_ERROR,
    SETCOMPANYUSERSFORMDATA_NULL_SUCCESS,
    SETCOMPANYUSERSFLAG_SUCCESS,
    GETCOMPANYUSERSDETAIL_SUCCESS,
    GETCOMPANYUSERSDETAIL_ERROR,
    SETCOMPANYACCOUNTFORMDATA_SUCCESS,
    SETCOMPANYACCOUNTFORMDATA_ERROR,
    SETCOMPANYACCOUNTFORMDATA_NULL_SUCCESS,
    SETCOMPANYACCOUNTFLAG_SUCCESS,
    GETCOMPANYACCOUNTDETAIL_SUCCESS,
    GETCOMPANYACCOUNTDETAIL_ERROR,
    SETCOMPANYACCOUNTANDPRODUCTFORMDATA_SUCCESS,
    SETCOMPANYACCOUNTANDPRODUCTFORMDATA_ERROR,
    SETCOMPANYACCOUNTANDPRODUCTFORMDATA_NULL_SUCCESS,
    SETCOMPANYACCOUNTANDPRODUCTFLAG_SUCCESS,
    GETCOMPANYACCOUNTANDPRODUCT_SUCCESS,
    GETCOMPANYACCOUNTANDPRODUCT_ERROR,
    SETCOMPANYGROUPFORMDATA_SUCCESS,
    SETCOMPANYGROUPFORMDATA_ERROR,
    SETCOMPANYGROUPFORMDATA_NULL_SUCCESS,
    SETCOMPANYGROUPFLAG_SUCCESS,
    GETCOMPANYGROUPDETAIL_SUCCESS,
    GETCOMPANYGROUPDETAIL_ERROR,
    GETCOMPANYACCOUNTAUTHORIZATION_SUCCESS,
    GETCOMPANYACCOUNTAUTHORIZATION_ERROR,
    GETPARSERHEADFURTHERDETAILS_SUCCESS,
    SETPARSEREDITFLAG_SUCCESS,
    GETPARSERHEADFURTHERDETAILS_ERROR,
    GETCOMPANYPARSERLINKEDHEADDETAILS_SUCCESS,
    GETCOMPANYPARSERLINKEDHEADDETAILS_ERROR,
    SETPARSERHEADDETAILSEDITFLAG_SUCCESS,
} = slice.actions;
export default slice.reducer;
